import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { UserControls } from "../Common/UserControls/UserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameManager } from "../../Managers/GameManager";
import { GameData } from "../Common/Datas/GameData";
import { GameActions } from "../Common/Actions/GameActions";
import { AppContext } from "../../../Common/AppContext";
import { ModuleManager } from "../../Managers/ModuleManager";
import { DataManager } from "../../Managers/DataManager";
import { LimitDialog } from "../Common/Dialogs/LimitDialog";
import { FreespinsController } from "../../GameComponents/Freespins/FreespinsController";
import { FreespinsActions } from "../Common/Actions/FreespinsActions";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Configuration } from "../../Components/Configuration";
import { FreeRoundBonus } from "../Common/Bonuses/FreeRoundBonus";

var GameModules = Communication.Game.GameModules;
var WinType = Communication.Game.WinType;

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopFreespinsUserControls extends UserControls {
    protected _controller: FreespinsController;

    private _userControls: HTMLElement;
    private _userControls_supreme: HTMLElement;
    private _afterWinDelay: FrameTimerEventEmitter;
    private _autoplayDelay: FrameTimerEventEmitter;
    private _updateRetriggerCountDelay: FrameTimerEventEmitter;
    private _wildMultiplierCountDelay: FrameTimerEventEmitter;
    private _wildMultiplierCountActiveDelay: FrameTimerEventEmitter;
    private _backDelay: FrameTimerEventEmitter;
    private _backButtonDelay: FrameTimerEventEmitter;
    private _prepareNewGameRound: FrameTimerEventEmitter;

    private _fsMultiplier: HTMLElement;
    private _fsRetrigger: HTMLElement;

    private _wasCalclulated: boolean = true;

    constructor() {
        super("freespins");
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._afterWinDelay = CreateFrameTimer("afterWinDelay");
        this._afterWinDelay.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._autoplayDelay = CreateFrameTimer("autoplayDelay");
        this._autoplayDelay.on(FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));

        this._updateRetriggerCountDelay = CreateFrameTimer("updateRetriggerCountDelay");
        this._updateRetriggerCountDelay.on(FrameTimerEvents.Complete, this.updateRetriggerCount.bind(this, true));

        this._wildMultiplierCountDelay = CreateFrameTimer("wildMultiplierCountDelay");
        this._wildMultiplierCountDelay.on(FrameTimerEvents.Complete, this.wildMultiplierCount.bind(this, true));

        this._backDelay = CreateFrameTimer("backDelay");
        this._backDelay.on(FrameTimerEvents.Complete, this.back.bind(this));

        this._backButtonDelay = CreateFrameTimer("backButtonDelay");
        this._backButtonDelay.on(FrameTimerEvents.Complete, this.backButton.bind(this));

        this._prepareNewGameRound = CreateFrameTimer("prepareNewGameRound");
        this._prepareNewGameRound.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._userControls = document.getElementById("freespinsUserControls");

        this._fsMultiplier = document.getElementById("fsMultiplier");
        this._fsRetrigger = document.getElementById("fsRetrigger");

        this._wildMultiplierCountActiveDelay = CreateFrameTimer("wildMultiplierCountActiveDelay");
        this._wildMultiplierCountActiveDelay.on(
            FrameTimerEvents.Complete,
            this.setCountHolderActive.bind(this, this._fsMultiplier, true),
        );
    }

    setMultipliersFromConfiguration(reset: boolean = false): void {
        let multipliers: Array<string> = [];
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            let config: Element = Configuration.Configurations["PaytableConfiguration"];
            if (config != null) {
                let next: Element = config.firstElementChild;
                while (next != null) {
                    if (next.hasAttribute("Symbol")) {
                        let id: number = parseInt(next.getAttribute("Symbol"));

                        if (GameManager.freespinsResponse.customData["selectedSymbol"] == id) {
                            if (next.hasAttribute("Multipliers")) {
                                multipliers = next.getAttribute("Multipliers").split(";");
                            }
                            break;
                        }
                    }
                    next = next.nextElementSibling;
                }
            }
        }

        if (reset) {
            multipliers[0] = "";
            multipliers[1] = "";
            multipliers[2] = "";
        } else {
            multipliers[0] = multipliers[0] != null ? "x" + multipliers[0] : "";
            multipliers[1] = multipliers[1] != null ? "x" + multipliers[1] : "";
            multipliers[2] = multipliers[2] != null ? "x" + multipliers[2] : "";
        }

        DataManager.updateDataElement(GameData.DataFreeSpinsPossibleWildMultiplier + "1", multipliers[0]);
        DataManager.updateDataElement(GameData.DataFreeSpinsPossibleWildMultiplier + "2", multipliers[1]);
        DataManager.updateDataElement(GameData.DataFreeSpinsPossibleWildMultiplier + "3", multipliers[2]);
    }

    addController(controller: FreespinsController): void {
        this._controller = controller;
        this._controller.on(FreespinsController.StartReceived, this.startReceived.bind(this));
        this._controller.on(FreespinsController.SpinReceived, this.spinReceived.bind(this));
        this._controller.on(FreespinsController.EndReceived, this.endReceived.bind(this));
        this._controller.on(FreespinsController.MachineStopped, this.machineStopped.bind(this));
        this._controller.on(FreespinsController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(FreespinsController.AllWinsFinished, this.allWinsFinished.bind(this));
        this._controller.on(FreespinsController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(FreespinsController.OutroFinished, this.outroFinished.bind(this));
        this._controller.on(
            FreespinsController.QuickWinCalculationFinished,
            this.quickWinCalculationFinished.bind(this),
        );
    }

    registerActions(): void {
        this.actions.registerActions({
            [FreespinsActions.ActionStart]: false,
            [FreespinsActions.ActionBack]: false,
            [FreespinsActions.ActionAutoplay]: false,
            [FreespinsActions.ActionAutoplayStop]: false,
            [FreespinsActions.ActionSpin]: false,
            [FreespinsActions.ActionSpinStop]: false,
        });
    }

    initReceived(): void {
        this._userControls_supreme = document.getElementById("userControls_supreme");

        super.initReceived();

        this._controller.initReceived();

        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            //this._userControls.classList.add(HtmlController.DisabledClass);
        }

        this.setMultipliersFromConfiguration();
    }

    restoreGameRound(): void {
        this.prepareNewGameRound();
    }

    startReceived(): void {
        ModuleManager.outroModule(GameModules.Base);

        this.setMultipliersFromConfiguration();
    }

    spinReceived(): void {
        if (DataManager.quickspinEnabled()) {
            // auto quick stop
            this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);
            HtmlController.updateActionElements(this.getAllActions());
            HtmlController.dispatchUiAction("");
            this._controller.stop();
        } else {
            this.actions.changeActionState(
                FreespinsActions.ActionSpinStop,
                AppContext.gameConfiguration.GameEnableReelsStop,
            );
            HtmlController.updateActionElements(this.getAllActions());
        }
    }

    endReceived(): void {
        ModuleManager.outroModule(GameModules.Freespins);
    }

    dispatchAction(action: string): void {
        if (action === GameActions.ActionSpinOrStop) {
            if (this.actions.getActionState(FreespinsActions.ActionBack)) {
                action = FreespinsActions.ActionBack;
            } else if (this.actions.getActionState(FreespinsActions.ActionSpin)) {
                action = FreespinsActions.ActionSpin;
            } else if (this.actions.getActionState(FreespinsActions.ActionSpinStop)) {
                action = FreespinsActions.ActionSpinStop;
            } else {
                return;
            }
        }

        if (this.actions.getActionState(action)) {
            super.dispatchAction(action);

            switch (action) {
                // case FreespinsActions.ActionStart:
                //     this.start();
                //     break;
                case FreespinsActions.ActionBack:
                    this.back();
                    break;
                case FreespinsActions.ActionSpin:
                    this.spin();
                    break;
                case FreespinsActions.ActionSpinStop:
                    this.stop();
                    break;
                case FreespinsActions.ActionAutoplay:
                    this.autoplay();
                    break;
                case FreespinsActions.ActionAutoplayStop:
                    this.autoplayStop();
                    break;
            }
        }
    }

    start(id: number): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.start(id);
    }

    spin(): void {
        if (!this._wasCalclulated) {
            if (GameManager.freespinsResponse != null && GameManager.freespinsResponse.currentWin > 0) {
                Platforms.Platforms.win(GameManager.freespinsResponse.currentWin);
            }
        }

        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            (GameManager.freespinsResponse.freeSpins.remainingCount - 1).toString(),
        );

        this._fsRetrigger.classList.remove("counterFlash");
        this._fsMultiplier.classList.remove("counterFlash");
        this._fsMultiplier.classList.remove("halfTone");

        if (this.getRetriggerCount()) {
            DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, this.getRetriggerCount().toString());
        } else {
            DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, "");
            this.setCountHolderActive(this._fsRetrigger, false);
        }

        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["wildMultiplier"] != null
        ) {
            DataManager.updateDataElement(GameData.DataFreeSpinsWildMultiplier, "");
            this.setCountHolderActive(this._fsMultiplier, false);
        }

        this.actions.disableAllActions();
        if (DataManager.Autoplay) {
            this.actions.changeActionState(FreespinsActions.ActionAutoplayStop, DataManager.autoplayEnabled());
        }
        HtmlController.dispatchUiAction("");
        DataManager.updateDataElement(GameData.DataTotalWin);
        HtmlController.updateActionElements(this.getAllActions());
        this._controller.spin();

        Platforms.Platforms.spinStarted();
    }

    back(): void {
        this._backDelay.stop();
        this.disable();
        ModuleManager.endFreespins();
    }

    stop(): void {
        this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);
        HtmlController.updateActionElements(this.getAllActions());
        HtmlController.dispatchUiAction("");
        DataManager.quickspinStopped();
        this._controller.stop();
    }

    end(): void {
        if (GameManager.freespinsResponse != null && GameManager.freespinsResponse.totalWin > 0) {
            Platforms.Platforms.win(GameManager.freespinsResponse.totalWin, true);
        }

        this._controller.end();
    }

    autoplayDelayed(): void {
        this._autoplayDelay.stop();
        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.prepareNewGameRound();
        }
    }

    autoplay(): void {
        this._afterWinDelay.stop();

        if (DataManager.AutoplayCount === "∞") {
            DataManager.Autoplay = true;
            DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
            this.spin();
        } else {
            DataManager.AutoplayCount = (parseInt(DataManager.AutoplayCount) - 1).toString();
            if (parseInt(DataManager.AutoplayCount) >= 0) {
                DataManager.Autoplay = true;
                DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
                this.spin();
            } else {
                DataManager.Autoplay = false;
                this.prepareNewGameRound();
            }
        }
    }

    autoplayStop(): void {
        DataManager.Autoplay = false;
        this.actions.changeActionState(FreespinsActions.ActionAutoplayStop, false);
        HtmlController.updateActionElement(FreespinsActions.ActionAutoplayStop, false);
    }

    backButton(): void {
        this.actions.changeActionState(FreespinsActions.ActionBack, true);
        HtmlController.updateActionElement(FreespinsActions.ActionBack, true);
    }

    machineStopped(): void {
        Platforms.Platforms.spinEnded();

        if (GameManager.freespinsResponse.currentWin === 0) {
            this._wasCalclulated = true;
        } else {
            this._wasCalclulated = false;
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            //this._afterWinDelay.start(30);

            let hasScatterFreespinWin = false;

            for (let i = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    if (GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.freeSpins) {
                        hasScatterFreespinWin = true;
                    }
                } else if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Way) {
                    if (GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.Cash) {
                    }
                }
            }

            if (hasScatterFreespinWin) {
                this._updateRetriggerCountDelay.start(120);
                this.setCountHolderActive(this._fsRetrigger, true);

                if (
                    GameManager.freespinsResponse.hasOwnProperty("customData") &&
                    GameManager.freespinsResponse.customData["wildMultiplier"] != null
                ) {
                    this._afterWinDelay.start(240);
                    this._wildMultiplierCountDelay.start(240);
                    this._wildMultiplierCountActiveDelay.start(120);
                } else {
                    this._afterWinDelay.start(120);
                }
            } else {
                if (
                    GameManager.freespinsResponse.hasOwnProperty("customData") &&
                    GameManager.freespinsResponse.customData["wildMultiplier"] != null
                ) {
                    this._afterWinDelay.start(120);
                    this._wildMultiplierCountDelay.start(120);
                    this.setCountHolderActive(this._fsMultiplier, true);
                } else {
                    this._afterWinDelay.start(30);
                }
            }
        }

        if (this.isLastFreespin()) {
            this._afterWinDelay.stop();
            DataManager.Autoplay = false;
            this.actions.disableAllActions();
            if (GameManager.freespinsResponse.currentWin === 0) {
                if (GameManager.freespinsResponse.totalWin != null) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataFreeSpinTotalWin,
                        GameManager.freespinsResponse.totalWin.toString(),
                    );
                }
                DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

                // Autostart Configurator in case of retrigger > 0. Else show back-button to basegame.
                if (this.getRetriggerCount() > 0 && !DataManager.GameLimit) {
                    this._backDelay.start(15);
                } else {
                    this._backButtonDelay.start(60);
                }
            }
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);

        if (GameManager.freespinsResponse.currentWin === 0) {
            this.prepareNewGameRound();
        }

        HtmlController.updateActionElements(this.getAllActions());

        if (DataManager.Autoplay && GameManager.freespinsResponse.currentWin === 0) {
            this._autoplayDelay.start(15);
        }
    }

    quickWinCalculationFinished(): void {
        if (
            GameManager.freespinsResponse != null &&
            GameManager.freespinsResponse.currentWin > 0 &&
            !this._wasCalclulated
        ) {
            Platforms.Platforms.win(GameManager.freespinsResponse.currentWin);
        }

        this._wasCalclulated = true;
        DataManager.updateDataElement(GameData.DataTotalWin);
    }

    winCalculationFinished(): void {
        this._afterWinDelay.stop();

        DataManager.updateDataElement(GameData.DataTotalWin);

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (this.isLastFreespin()) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    allWinsFinished(): void {
        if (
            GameManager.freespinsResponse != null &&
            GameManager.freespinsResponse.currentWin > 0 &&
            !this._wasCalclulated
        ) {
            Platforms.Platforms.win(GameManager.freespinsResponse.currentWin);
        }

        this._wasCalclulated = true;

        this._afterWinDelay.stop();

        if (this.isLastFreespin()) {
            DataManager.Autoplay = false;
            this.actions.disableAllActions();

            // Autostart Configurator in case of retrigger > 0. Else show back-button to basegame.
            if (this.getRetriggerCount() > 0 && !DataManager.GameLimit) {
                this.back();
            } else {
                this._backButtonDelay.start(60);
            }

            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
        if (DataManager.Autoplay) {
            this.autoplay();
        }
    }

    initIntro(): void {
        FreeRoundBonus.disableUi();
        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
        );

        DataManager.updateDataElement(GameData.DataTotalWin);

        this._fsRetrigger.classList.remove("_disabled");
        this._fsMultiplier.classList.remove("_disabled");
        this.updateRetriggerCount(false, true);
        this.wildMultiplierCount(false, true);

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }
        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            //ToDo je potrebne kontrolovat contains ?
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }
        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }

        super.initIntro();
        this._controller.initIntro();
        Platforms.Platforms.featureInit({ type: Communication.Game.GameModules.Freespins });

        if (this.isLastFreespin()) {
            this.actions.disableAllActions();

            // Autostart Configurator in case of retrigger > 0. Else show back-button to basegame.
            if (this.getRetriggerCount() > 0 && !DataManager.GameLimit) {
                this._backDelay.start(15);
            } else {
                this._backButtonDelay.start(60);
            }

            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.prepareNewGameRound();
    }

    intro(long: boolean = false): void {
        FreeRoundBonus.disableUi();
        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
        );

        this._fsRetrigger.classList.remove("_disabled");
        this._fsMultiplier.classList.remove("_disabled");
        this.updateRetriggerCount(false, true);
        this.wildMultiplierCount(false, true);

        this._controller.intro(long);

        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }
    }

    introFinished(): void {
        this._prepareNewGameRound.start(60);
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
    }

    outro(): void {
        DataManager.Autoplay = false;

        this.setMultipliersFromConfiguration(true);
        DataManager.updateDataElement(GameData.DataFreeSpinsWildMultiplier, "");
        this.setCountHolderActive(this._fsMultiplier, false);

        if (!this.getRetriggerCount()) {
            this._fsMultiplier.classList.add("_disabled");

            this.setCountHolderActive(this._fsRetrigger, false);
            this._fsRetrigger.classList.add("_disabled");
        }

        this._controller.outro();

        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }
    }

    outroFinished(): void {
        ModuleManager.introModule(GameModules.Base, true);
        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
    }

    /**
     * Update retrigger value in holder.
     */
    updateRetriggerCount(animate: boolean = false, active: boolean = false): void {
        this._updateRetriggerCountDelay.stop();

        if (this.getRetriggerCount()) {
            DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, this.getRetriggerCount().toString());
            if (animate) {
                this._fsRetrigger.classList.add("counterFlash");
                PlayList.play("SND_FSeyeline03");
            }
            if (active) {
                this.setCountHolderActive(this._fsRetrigger, true);
            }
        } else {
            DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, "");
            this.setCountHolderActive(this._fsRetrigger, false);
        }
    }

    /**
     * Update wild multiplier value in holder.
     */
    wildMultiplierCount(animate: boolean = false, active: boolean = false): void {
        this._wildMultiplierCountDelay.stop();
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["wildMultiplier"] != null
        ) {
            if (GameManager.freespinsResponse.customData["wildMultiplier"]) {
                DataManager.updateDataElement(
                    GameData.DataFreeSpinsWildMultiplier,
                    "x" + GameManager.freespinsResponse.customData["wildMultiplier"].toString(),
                );
                if (animate) {
                    this._fsMultiplier.classList.add("counterFlash");
                    PlayList.play("SND_FSeyeline03");
                }
                if (active) {
                    this.setCountHolderActive(this._fsMultiplier, true);
                }
            } else {
                DataManager.updateDataElement(GameData.DataFreeSpinsWildMultiplier, "");
            }
        } else {
            DataManager.updateDataElement(GameData.DataFreeSpinsWildMultiplier, "");
        }

        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            this._fsMultiplier.classList.remove("green");
            this._fsMultiplier.classList.remove("blue");
            this._fsMultiplier.classList.remove("white");
            this._fsMultiplier.classList.remove("red");
            this._fsMultiplier.classList.remove("gold");

            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    this._fsMultiplier.classList.add("green");
                    break;
                case 8:
                    this._fsMultiplier.classList.add("blue");
                    break;
                case 9:
                    this._fsMultiplier.classList.add("white");
                    break;
                case 10:
                    this._fsMultiplier.classList.add("red");
                    break;
                case 11:
                    this._fsMultiplier.classList.add("gold");
                    break;
            }
        }
    }

    private setCountHolderActive(elem: HTMLElement, active: boolean): void {
        if (elem != null) {
            if (active) {
                elem.classList.add("_active");
            } else {
                elem.classList.remove("_active");
            }
        }
    }

    prepareNewGameRound(): void {
        this._afterWinDelay.stop();

        if (GameManager.freespinsResponse.totalWin != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataFreeSpinTotalWin,
                GameManager.freespinsResponse.totalWin.toString(),
            );
        }
        DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

        if (DataManager.GameLimit) {
            DataManager.Autoplay = false;
            this.limit();
        } else {
            if (!DataManager.Autoplay) {
                this.actions.changeActionStates({
                    [FreespinsActions.ActionStart]: false,
                    [FreespinsActions.ActionBack]: false,
                    [FreespinsActions.ActionAutoplay]: !DataManager.Autoplay && DataManager.autoplayEnabled(),
                    [FreespinsActions.ActionAutoplayStop]: DataManager.Autoplay && DataManager.autoplayEnabled(),
                    [FreespinsActions.ActionSpin]: true,
                    [FreespinsActions.ActionSpinStop]: false,
                });
            }
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    limit(): void {
        LimitDialog.openDialog();

        this.actions.changeActionStates({
            [FreespinsActions.ActionStart]: false,
            [FreespinsActions.ActionBack]: false,
            [FreespinsActions.ActionAutoplay]: false,
            [FreespinsActions.ActionAutoplayStop]: false,
            [FreespinsActions.ActionSpin]: false,
            [FreespinsActions.ActionSpinStop]: false,
        });
    }

    enable(): void {
        DataManager.updateDataElement(
            GameData.DataFreeSpinsRemainingCount,
            GameManager.freespinsResponse.freeSpins.remainingCount.toString(),
        );
        DataManager.updateDataElement(
            GameData.DataFreeSpinsCount,
            GameManager.freespinsResponse.freeSpins.totalCount.toString(),
        );
        this.actions.changeActionState(FreespinsActions.ActionStart, true);
        HtmlController.updateActionElement(FreespinsActions.ActionStart, true);
        this._controller.enable();
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }

    /**
     *
     * @returns {boolean}
     */
    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            this.limit();
            return true;
        }

        if (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        ) {
            return true;
        }

        return false;
    }

    /**
     * Get remaining retriggers.
     * @returns {number}
     */
    private getRetriggerCount(): number {
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["retriggerCount"] != null
        ) {
            return GameManager.freespinsResponse.customData["retriggerCount"];
        }

        return null;
    }

    /**
     *
     * @param show
     */
    public showMultiplierHolder(show: boolean): void {
        if (show) {
            this._fsMultiplier.classList.remove("_disabled");
        } else {
            this._fsMultiplier.classList.add("_disabled");
        }
    }

    /**
     *
     * @param show
     * @param decrement
     */
    public showRetriggerHolder(show: boolean, decrement: boolean = false): void {
        if (show) {
            this._fsRetrigger.classList.remove("_disabled");

            if (this.getRetriggerCount()) {
                DataManager.updateDataElement(
                    GameData.DataFreeSpinsBonusRetrigger,
                    this.getRetriggerCount().toString(),
                );
                this.setCountHolderActive(this._fsRetrigger, true);
            } else {
                DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, "");
                this.setCountHolderActive(this._fsRetrigger, false);
            }
        } else {
            this._fsRetrigger.classList.add("_disabled");

            if (decrement) {
                if (this.getRetriggerCount() > 1) {
                    DataManager.updateDataElement(
                        GameData.DataFreeSpinsBonusRetrigger,
                        (this.getRetriggerCount() - 1).toString(),
                    );
                } else {
                    DataManager.updateDataElement(GameData.DataFreeSpinsBonusRetrigger, "");
                    this.setCountHolderActive(this._fsRetrigger, false);
                }
            }
        }
    }

    /**
     *
     * @param {boolean} highlight
     */
    public highlightFreespinMultiplierValue(highlight: boolean): void {
        this._fsMultiplier.classList.remove("counterFlash");

        //hack for restarting animation
        void this._fsMultiplier.offsetWidth;

        if (highlight) {
            this._fsMultiplier.classList.remove("halfTone");
            this._fsMultiplier.classList.add("counterFlash");
        } else {
            this._fsMultiplier.classList.add("halfTone");
        }
    }

    setSceneAnimations(sceneIndex: number): void {
        this._controller.setSceneAnimations(sceneIndex);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopFreespinsUserControls.ts
 **/